import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../data/translations';

export const useTranslation = () => {
  const { language } = useLanguage();
  
  const t = (key, defaultValue = '') => {
    const result = getTranslation(language, key) || defaultValue || key;
    return result;
  };
  
  return { t, language };
};